import gsap from 'gsap';

export default class NavbarCollapse {
    constructor(options = {}) {
        const { trigger, node } = options;

        // Required elements are not provided or cannot be found
        if (!trigger || !node) {
            console.warn(
                `Please check your selector for \nTrigger: ${trigger}\nNode: ${node}`
            );
            return;
        }

        this.options = options;

        //Initial state
        this.active = false;

        this.buildTimeline();

        // Initial bind for performance
        this.handleClick = this.handleClick.bind(this);

        // Set trigger click event
        trigger.addEventListener('click', this.handleClick);
    }

    buildTimeline() {
        // Use custom timeline provided in options when provided
        if (this.options.timeline) {
            this.tl = this.options.timeline(this);
            return;
        }

        const { node } = this.options;
        const duration = this.options.duration ? this.options.duration : 0.5;

        // Build timeline
        this.tl = gsap.timeline({
            paused: true,
            onStart: () => {
                if (this.options.onStart) {
                    this.options.onStart();
                }
            },
            onComplete: () => {
                if (this.options.onComplete) {
                    this.options.onComplete();
                }
            },
            onReverseComplete: () => {
                if (this.options.onReverseComplete) {
                    this.options.onReverseComplete();
                }
            },
        });

        this.tl.to(node, {
            duration: duration,
            translateY: 0,
        });
    }

    handleClick(e) {
        if (e) {
            e.preventDefault();
        }

        // Update trigger ARIA expanded label
        this.options.trigger.setAttribute('aria-expanded', !this.active);

        // Play timeline
        this.play();
    }

    play() {
        if (this.active) {
            this.tl.reverse();
            if (this.options.onReverseStart) {
                this.options.onReverseStart();
            }
        } else {
            this.tl.play();
        }

        this.active = !this.active;
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/NavbarCollapse/navbar-collapse.js